import { render, staticRenderFns } from "./ProfitStatementList.vue?vue&type=template&id=d2959330&scoped=true"
import script from "./ProfitStatementList.vue?vue&type=script&lang=js"
export * from "./ProfitStatementList.vue?vue&type=script&lang=js"
import style0 from "./ProfitStatementList.vue?vue&type=style&index=0&id=d2959330&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2959330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2959330')) {
      api.createRecord('d2959330', component.options)
    } else {
      api.reload('d2959330', component.options)
    }
    module.hot.accept("./ProfitStatementList.vue?vue&type=template&id=d2959330&scoped=true", function () {
      api.rerender('d2959330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/gledger/ProfitStatementList.vue"
export default component.exports